import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, InputGroup, Form, Button, ButtonGroup } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';

import { AuthContext } from 'api/context';
import Save from 'components/Save';
import ValidationForm from 'components/Form/ValidationForm';

import './Hardware.module.css';

const MountingHardware = () => {
  const { newEndpoint, displaySnack } = useContext(AuthContext);
  const endpoint = newEndpoint('hardware/mounting/');

  const [mounting, setMounting] = useState([]);
  const [newMounting, setNewMounting] = useState();

  // componentDidMount
  useEffect(() => {
    endpoint.list()
      .then((data) => setMounting(data))
      .catch((e) => console.log(e));
  }, []);

  const handleUpdateField = (value, field, index) => {
    const updated = Array.from(mounting);
    updated[index][field] = value;
    setMounting(updated);
  };

  const handleUpdate = (mount) => {
    endpoint.update(mount.id, mount)
      .then(() => displaySnack({ variant: 'success', message: `Updated ${mount.model}.` }))
      .catch(() => displaySnack({ variant: 'danger', message: `Failed update ${mount.model}.` }));
  };

  const handleServiceability = (index) => {
    const updated = Array.from(mounting);
    updated[index].is_hidden = !updated[index].is_hidden;
    setMounting(updated);
  }

  const handleDelete = (index) => {
    const updated = Array.from(mounting);
    const rm = updated.splice(index, 1)[0];
    endpoint.remove(rm.id)
      .then(() => { setMounting(updated); displaySnack({ variant: 'success', message: `Deleted ${rm.id}.` }); })
      .catch(() => displaySnack({ variant: 'warning', message: `Failed to delete ${rm.model}` }));
  };

  const handleCreate = () => {
    // send POST request for new mount
    endpoint.create(newMounting)
      .then(() => endpoint.list().then((data) => setMounting(data)))
      .then(() => {
        displaySnack({ variant: 'success', message: `Added ${newMounting.model}.` });
        setNewMounting();
      })
      .catch(() => displaySnack({
        variant: 'danger',
        message: 'Failed to add new mounting hardware.',
      }));
  };

  // render() {
  return (
    <>
      <Row className="font-weight-bold mt-2">
        <Col sm={2}>Mounting Hardware</Col>
        <Col sm={2}>Cost</Col>
        <Col sm={3}>Cost Type</Col>
        <Col sm={2}>Serviceable</Col>
      </Row>

      {mounting.map((item, index) => (
        <Row key={item.id} className="mt-2">
          <Col sm={2}>{item.model}</Col>
          <Col sm={2}>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>$</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                value={item.cost}
                onChange={(e) => handleUpdateField(e.target.value, 'cost', index)}
              />
            </InputGroup>
          </Col>
          <Col sm={3} className="my-auto">
            <Form.Check
              inline
              id={`flat_cost_${index}`}
              type="radio"
              label="Flat"
              checked={item.flat_cost}
              onChange={() => handleUpdateField(true, 'flat_cost', index)}
            />
            <Form.Check
              inline
              id={`watt_cost_${index}`}
              type="radio"
              label="Per Watt"
              checked={!item.flat_cost}
              onChange={() => handleUpdateField(false, 'flat_cost', index)}
            />
          </Col>
          <Col sm={2}>
            <Form.Check checked={!item?.is_hidden} onClick={() => handleServiceability(index)} />
          </Col>
          <Col sm={2}>
            <ButtonGroup size="sm">
              <Button variant="outline-primary p-2" onClick={() => handleUpdate(item)}>
                <Save />
              </Button>
              <Button variant="outline-primary p-2" onClick={() => handleDelete(index)}>
                <Trash />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      ))}

      {/* New Monitoring System */}
      {newMounting === undefined ? (
        <Row className="mt-4">
          <Col>
            <Button onClick={() => setNewMounting({ flat_cost: true })}>
              + Add Mounting Hardware
            </Button>
          </Col>
        </Row>
      ) : (
        <ValidationForm onSave={handleCreate}>
          <Row className="mt-3">
            <Col sm={2}>
              <Form.Control
                required
                value={newMounting.model || ''}
                onChange={(e) => setNewMounting({ ...newMounting, model: e.target.value })}
              />
            </Col>
            <Col sm={2}>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  value={newMounting.cost || ''}
                  onChange={(e) => setNewMounting({ ...newMounting, cost: e.target.value })}
                />
              </InputGroup>
            </Col>
            <Col sm={3} className="my-auto">
              <Form.Check
                inline
                id="new_flat_cost"
                type="radio"
                label="Flat"
                checked={newMounting.flat_cost}
                onChange={() => setNewMounting({ ...newMounting, flat_cost: true })}
              />
              <Form.Check
                inline
                id="new_watt_cost"
                type="radio"
                label="Per Watt"
                checked={!newMounting.flat_cost}
                onChange={() => setNewMounting({ ...newMounting, flat_cost: false })}
              />
            </Col>
            <Col sm={1}>
              <Button variant="outline-primary p-2" size="sm" onClick={() => setNewMounting()}>
                <Trash />
              </Button>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Button type="submit">Save</Button>
            </Col>
          </Row>
        </ValidationForm>
      )}
    </>
  );
  // }
};

export default MountingHardware;
